import api from '@/store/api';
import { athena, boro } from '@/store/api/instances';
import type { ResolutionReason } from '@/types/serviceTicket';
import type { ApiListingRequest, ApiResponse } from '@bitstopco/bitstop-theme';

interface CreateResolutionReasonRequest {
  name: string;
  is_success_reason: boolean;
  description: string;
}

interface UpdateResolutionReasonRequest {
  id: string;
  name: string;
  is_success_reason: boolean;
  description: string;
  is_active?: boolean;
}

/**
 * RTK Query API for Resolution Reasons.
 */
export const resolutionReasonsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getResolutionReasons: build.query<ApiResponse<ResolutionReason[]>, ApiListingRequest | void>({
      query: (data) =>
        athena({
          url: 'v2/Operations/task-resolution-reasons',
          method: 'POST',
          data: data || {
            pagination: {
              current_page: 1,
              items_per_page: 1000,
              sort_by: 'name',
              sort_ascending: true,
            },
          },
        }),
      providesTags: ['ResolutionReasons'],
    }),
    createResolutionReason: build.mutation<
      ApiResponse<ResolutionReason>,
      CreateResolutionReasonRequest
    >({
      query: (data) =>
        boro({
          url: 'v2/operations/service-tickets/task-resolution-reasons',
          method: 'POST',
          data,
        }),
      invalidatesTags: ['ResolutionReasons'],
    }),
    updateResolutionReason: build.mutation<
      ApiResponse<ResolutionReason>,
      UpdateResolutionReasonRequest
    >({
      query: ({ id, ...data }) =>
        boro({
          url: `v2/operations/service-tickets/task-resolution-reasons/${id}`,
          method: 'PATCH',
          data,
        }),
      invalidatesTags: ['ResolutionReasons'],
    }),
    deleteResolutionReason: build.mutation<void, string>({
      query: (id) =>
        boro({
          url: `v2/operations/service-tickets/task-resolution-reasons/${id}`,
          method: 'DELETE',
        }),
      invalidatesTags: ['ResolutionReasons'],
    }),
  }),
});

export const {
  useGetResolutionReasonsQuery,
  useCreateResolutionReasonMutation,
  useUpdateResolutionReasonMutation,
  useDeleteResolutionReasonMutation,
} = resolutionReasonsApi;
